<template>
    <v-container>
        <v-card style="height: 350px !important;">
            <v-toolbar color="primary" dark>{{ titulo }}</v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-form ref="form" v-model="valid" lazy-validation>
                            <label class="typo__label" style="text-align: center;">Icono:</label>
                            <multiselect v-model="icon" deselect-label="No se puede remover el valor seleccionado"
                                label="icon" selected-label="Seleccionado" select-label="Seleccionar valor"
                                placeholder="Seleccionar opción" :options="materialIcons" :allow-empty="false"
                                :max-height="150">
                                <template slot="singleLabel" slot-scope="props">
                                    <div class="option__desc">
                                        <span class="option__title">
                                            <v-icon color="success">{{ props.option.icon }}</v-icon>
                                        </span>
                                    </div>
                                </template>
                                <template slot="option" slot-scope="props">
                                    <div class="option__desc">
                                        <span class="option__title">
                                            <v-icon color="success">{{ props.option.icon }}</v-icon>
                                        </span>
                                    </div>
                                </template>
                            </multiselect>
                            <span style="color: #ff4081;" v-if="validaicon">Selección requerida</span>
                            <br />
                            <label class="typo__label " style="text-align: center;">Nombre:</label>
                            <v-text-field outlined dense :counter="100"
                                :rules="[rules.required, rules.counter, rules.text]"
                                v-on:blur="nombre = nombre != null ? nombre.trim() : null" v-model="nombre">
                            </v-text-field>

                        </v-form>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="text-center">
                        <v-btn class="ma-2" color="primary" @click="Guardar()">
                            Guardar
                            <template v-slot:loader>
                                <span>Loading...</span>
                            </template>
                        </v-btn>
                        <v-btn class="ma-2" color="default" @click="Limpiar2()">
                            Cerrar
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';
export default {
    props: {
        Arraycategorias: {
            type: Array,
            default: [],
        },
        Datosreporte: {
            type: Object,
            default: {},
        }
    },
    data: function () {
        return {
            validaicon: false,
            user: '',
            valid: true,
            nombre: null,
            icon: '',
            id: '',
            total: 0,
            rules: {
                required: value => !!value || 'Campo requerido',
                counter: value => {
                    if (value == null || value == '') {
                        return true
                    }
                    else {
                        return value.length >= 3 || 'Minino 3 caracteres'
                    }
                },
                text: value => {
                    if (value == null || value == '') {
                        return true
                    }
                    else {
                        return value.length <= 100 || 'Máximo 100 caracteres'
                    }
                },
            },
            materialIcons: [],
            titulo: 'Nueva Categoría',
            sending: false,
        }
    },
    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    watch: {
        'icon': function () {
            if (this.icon != '')
                this.validaicon = false;
            else
                this.validaicon = true;
        },
        async 'Arraycategorias'(val) {
            let data = await General.ObtenerIcono();
            // Tu string con objetos JS
            var datos = data[0].Column1;

            // Reemplaza los nombres de propiedades para que tengan comillas
            var datosJson = datos.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');

            // Ahora puedes parsearlo como JSON
            var iconsArray = JSON.parse(datosJson);
            this.materialIcons = iconsArray;
            let formdata = new FormData();
            formdata.append("uslogin", this.user);
            let categorias = await General.ObtenerCategorias(formdata);
            for (let index in categorias) {
                this.materialIcons = this.materialIcons.filter(item => item.icon != categorias[index].cficon);
            }
        }
    },
    methods: {
        async Guardar() {
            if (this.icon == '' || this.icon == null)
                this.validaicon = true;
            if (this.$refs.form.validate() && !this.validaicon) {
                if (this.sending) { // Verifica si ya se está enviando
                    return; // Si es así, no hace nada
                }
                this.sending = true;
                let formdata = new FormData();
                formdata.append("uslogin", this.user);
                let categorias = await General.ObtenerCategorias(formdata);
                this.total = categorias.length;
                if (this.total >= 10 && this.id == '') {
                    this.$swal(
                        "Atención",
                        "No se puede agregar más categorías, ha alcanzado el límite",
                        "info"
                    );
                }
                else {
                    this.$swal.showLoading();
                    let formdata = new FormData();
                    formdata.append("nombre", this.nombre);
                    formdata.append("icon", this.icon.icon);
                    formdata.append("uslogin", this.user);
                    let data = await General.ValidacionCategorias(formdata);
                    if (!data) {
                        if (this.id == '') {
                            let data = await General.NuevaCategoria(formdata);
                            if (data.success) {
                                this.$emit("nuevo");
                                this.nombre = null;
                                this.icon = null;
                                this.validaicon = false;
                                this.$refs.form.reset();
                                this.$emit("eventoCargarFav");

                                let form = new FormData();
                                form.append("nrreporte", this.Datosreporte.nrreporte);
                                form.append("svindice", this.Datosreporte.svindice);
                                form.append("uslogin", this.user);
                                form.append("frid", 0);
                                form.append("cfid", data.result);
                                let contador = await General.ContadorFavorito(form);
                                if (contador.success && contador.result[0].contador == 3) {
                                    this.$swal({
                                        position: "center",
                                        icon: "info",
                                        title: "Advertencia!",
                                        html: "Se creó la nueva categoría, pero no se asignó al reporte, ya que alcanzó el máximo de 3 categorías que se puede asignar.",
                                        confirmButtonText: "Aceptar",
                                        showConfirmButton: true,
                                        allowEscapeKey: false,
                                        allowOutsideClick: false,
                                        timer: 5000,
                                    }).then((result) => {

                                    });
                                } else if (contador.success && contador.result[0].contador < 3 && contador.result[0].existe == 0) {
                                    let response = await General.GuardarFavorito(form);
                                    if (response.success) {
                                        this.$swal({
                                            position: "center",
                                            icon: "success",
                                            title: "Éxito!",
                                            text: "Se creo y se asignó la nueva categoría correctamente",
                                            confirmButtonText: "Aceptar",
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                            timer: 4000,
                                        });
                                        this.$emit("eventoCargarFav");
                                    }
                                    else {
                                        this.$swal({
                                            position: "center",
                                            icon: "error",
                                            title: "Error!",
                                            html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                            confirmButtonText: "Aceptar",
                                            showConfirmButton: true,
                                            allowOutsideClick: false,
                                            timer: 4000,
                                        }).then((result) => {

                                        });
                                    }
                                }


                            }
                            else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: "Error!",
                                    html: "No se puede guardar, por favor intente de nuevo más tarde, si el problema persiste, pónganse en contacto con el equipo de asistencia técnica",
                                    confirmButtonText: "Aceptar",
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    timer: 4000,
                                }).then((result) => {
                                });
                            }
                        }
                    } else {
                        this.$swal(
                            "Atención",
                            "Este icono ya fue utilizado en otra categoría, favor de verificar o cambiarlo.",
                            "info"
                        );
                    }
                }
                this.sending = false;
            }
        },
        Limpiar2() {
            this.nombre = null;
            this.icon = null;
            this.validaicon = false;
            this.$refs.form.reset();
            this.$emit("Cerrar");

        },
    },
        async mounted() {
        this.validaicon = false;
            let data = await General.ObtenerIcono();
            // Tu string con objetos JS
            var datos = data[0].Column1;

            // Reemplaza los nombres de propiedades para que tengan comillas
            var datosJson = datos.replace(/([{,]\s*)(\w+)\s*:/g, '$1"$2":');

            // Ahora puedes parsearlo como JSON
            var iconsArray = JSON.parse(datosJson);
            this.materialIcons = iconsArray;
        this.user = await MetodosGenerales.ObtenerUserName();

        let formdata = new FormData();
        formdata.append("uslogin", this.user);
        let categorias = await General.ObtenerCategorias(formdata);
        for (let index in categorias) {
            this.materialIcons = this.materialIcons.filter(item => item.icon != categorias[index].cficon);
        }
    }
}
</script>